// PageAutodisplayViewLinkEduMobile.jsx
// 모바일 전용 자동 디스플레이 링크 페이지 (전체화면 기능 없음)

import React, { useState, useEffect, useRef, useCallback } from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import {
  AUTODISPLAY_SELECTED_CONTENT,
  AUTODISPLAY_ACTIVE_DPI_INFO,
  AUTODISPLAY_EDU_VIEW_DESIGN_CONCEPT,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_TITLE,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_MARKDOWN,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_JSON,
  AUTODISPLAY_EDU_VIEW_CONTENTS_PURPOSE,
  AUTODISPLAY_EDU_VIEW_CONTENTS_TYPE,
  AUTODISPLAY_EDU_VIEW_CONTENTS_MEAL,
  AUTODISPLAY_EDU_VIEW_NUTRITION_MESSAGE,
  AUTODISPLAY_EDU_VIEW_LOTATION_DATA_ALL,
  AUTODISPLAY_EDU_VIEW_LOTATION_DATA_GRADE1,
  AUTODISPLAY_EDU_VIEW_LOTATION_DATA_GRADE2,
  AUTODISPLAY_EDU_VIEW_LOTATION_DATA_GRADE3,
} from "../../AtomStates";
import { useAtom } from "jotai";
import {
  viewDetailActivateLinkEduRequest,
  viewDetailActivateLinkEduLotationRequest,
  getOpenWeatherData,
  getWeatherData,
  getWeatherForecastData,
  getWeatherDataInDB,
} from "../../../utils/indexedDB";
import MoleculeBackgroundSimpleWide from "../../CreateEducationContentPage/components/molecules/MoleculeBackgroundSimpleWide";
import MoleculeBackgroundSimpleWideLink from "../../CreateEducationContentPage/components/molecules/MoleculeBackgroundSimpleWideLink";
import MoleculeMenuBoard from "../../CreateEducationContentPage/components/molecules/MoleculeMenuBoard";
import MoleculePlayFloating from "../../Global/components/molecules/MoleculePlayFloating";
import MoleculeFullScreenButton from "../../Global/components/molecules/MoleculeFullScreenButton";

const PageAutodisplayViewLinkEduMobileLotation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [autoDisplaySelectedContent, setAutoDisplaySelectedContent] = useAtom(
    AUTODISPLAY_SELECTED_CONTENT
  );

  const [autoDisplayActiveDPIInfo, setAutoDisplayActiveDPIInfo] = useAtom(
    AUTODISPLAY_ACTIVE_DPI_INFO
  );

  // URL 파라미터와 쿼리 파라미터 모두 처리
  const { path } = useParams();
  const [viewId, setViewId] = useState(null);
  const [gradeState, setGradeState] = useState(null);
  const [urlChecked, setUrlChecked] = useState(false);
  const [activateTimestamp, setActivateTimestamp] = useState("");
  const [isConnecting, setIsConnecting] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  
  const [
    autoDisplayEduViewLotationDataAll,
    setAutoDisplayEduViewLotationDataAll,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_LOTATION_DATA_ALL);
  const [
    autoDisplayEduViewLotationDataGrade1,
    setAutoDisplayEduViewLotationDataGrade1,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_LOTATION_DATA_GRADE1);
  const [
    autoDisplayEduViewLotationDataGrade2,
    setAutoDisplayEduViewLotationDataGrade2,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_LOTATION_DATA_GRADE2);
  const [
    autoDisplayEduViewLotationDataGrade3,
    setAutoDisplayEduViewLotationDataGrade3,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_LOTATION_DATA_GRADE3);

  const [autoDisplayEduViewDesignConcept, setAutoDisplayEduViewDesignConcept] =
    useAtom(AUTODISPLAY_EDU_VIEW_DESIGN_CONCEPT);
  const [autoDisplayEduViewContentsType, setAutoDisplayEduViewContentsType] =
    useAtom(AUTODISPLAY_EDU_VIEW_CONTENTS_TYPE);
  const [autoDisplayEduViewContentsMeal, setAutoDisplayEduViewContentsMeal] =
    useAtom(AUTODISPLAY_EDU_VIEW_CONTENTS_MEAL);
  const [
    autoDisplayEduViewNutritionMessage,
    setAutoDisplayEduViewNutritionMessage,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_NUTRITION_MESSAGE);

  // 현재 표시할 콘텐츠 상태 관리
  const [currentContentIndex, setCurrentContentIndex] = useState(0);
  const [currentContent, setCurrentContent] = useState(null);
  const [lotationTime, setLotationTime] = useState(30); // 기본 30초
  const [playing, setPlaying] = useState(true); // 재생/일시정지 상태
  const rotationTimerRef = useRef(null);
  const dataRefreshTimerRef = useRef(null);
  const lastDataFetchTimeRef = useRef(0);
  const retryTimeoutRef = useRef(null);

  // 날씨 데이터 상태 추가
  const [weatherData, setWeatherData] = useState({
    temperature: null,
    sky: null, // 1: 맑음, 3: 구름많음, 4: 흐림
    pty: null, // 강수형태
  });
  const weatherTimerRef = useRef(null);

  console.log("📱 모바일 전용 컴포넌트 렌더링 (전체화면 기능 없음)");

  const [
    autoDisplayEduViewContentGeneratorTitle,
    setAutoDisplayEduViewContentGeneratorTitle,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_TITLE);
  const [
    autoDisplayEduViewContentGeneratorMarkdown,
    setAutoDisplayEduViewContentGeneratorMarkdown,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_MARKDOWN);
  const [
    autoDisplayEduViewContentGeneratorJson,
    setAutoDisplayEduViewContentGeneratorJson,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_JSON);
  const [
    autoDisplayEduViewContentsPurpose,
    setAutoDisplayEduViewContentsPurpose,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENTS_PURPOSE);

  const [linkUrl, setLinkUrl] = useState("");

  // 화면 스케일링 상태 관리
  const [scale, setScale] = useState({ x: 1, y: 1 });

  useEffect(() => {
    const updateScale = () => {
      const scaleX = window.innerWidth / 3840;
      const scaleY = window.innerHeight / 2160;
      const ratio = Math.min(scaleX, scaleY);
      setScale({ x: ratio, y: ratio });
    };

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  // 스크롤바 강제 제거
  useEffect(() => {
    // body와 html에 overflow hidden 적용
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, []);

  // 날씨 API 파라미터 계산 함수
  const calculateWeatherParams = (currentTime) => {
    const year = currentTime.getFullYear();
    const month = String(currentTime.getMonth() + 1).padStart(2, "0");
    const day = String(currentTime.getDate()).padStart(2, "0");
    const hour = currentTime.getHours();

    let base_date_obj = new Date();
    let base_time = "";

    // 초단기실황 API는 매시 45분 이후에 데이터가 제공됩니다.
    if (currentTime.getMinutes() < 45) {
      if (hour === 0) {
        base_date_obj.setDate(base_date_obj.getDate() - 1);
        base_time = "2300";
      } else {
        base_time = `${String(hour - 1).padStart(2, "0")}00`;
      }
    } else {
      base_time = `${String(hour).padStart(2, "0")}00`;
    }

    const base_date = `${base_date_obj.getFullYear()}${String(
      base_date_obj.getMonth() + 1
    ).padStart(2, "0")}${String(base_date_obj.getDate()).padStart(2, "0")}`;

    return {
      pageNo: 1,
      numOfRows: 10,
      dataType: "JSON",
      base_date: base_date,
      base_time: base_time,
      nx: 61,
      ny: 125,
    };
  };

  // 날씨 예보 API 파라미터 계산 함수
  const calculateForecastParams = (currentTime) => {
    const year = currentTime.getFullYear();
    const month = String(currentTime.getMonth() + 1).padStart(2, "0");
    const day = String(currentTime.getDate()).padStart(2, "0");
    const hour = currentTime.getHours();

    // API 발표 시간 기준
    let baseTime;
    if (hour >= 23) {
      baseTime = "2300";
    } else if (hour >= 20) {
      baseTime = "2000";
    } else if (hour >= 17) {
      baseTime = "1700";
    } else if (hour >= 14) {
      baseTime = "1400";
    } else if (hour >= 11) {
      baseTime = "1100";
    } else if (hour >= 8) {
      baseTime = "0800";
    } else if (hour >= 5) {
      baseTime = "0500";
    } else {
      baseTime = "0200";
    }

    // 새벽 시간대는 전날 데이터 사용
    let baseDate;
    if (hour < 2) {
      const yesterday = new Date(currentTime);
      yesterday.setDate(yesterday.getDate() - 1);
      baseDate = `${yesterday.getFullYear()}${String(
        yesterday.getMonth() + 1
      ).padStart(2, "0")}${String(yesterday.getDate()).padStart(2, "0")}`;
      baseTime = "2300";
    } else {
      baseDate = `${year}${month}${day}`;
    }

    return {
      pageNo: 1,
      numOfRows: 12,
      dataType: "JSON",
      base_date: baseDate,
      base_time: baseTime,
      nx: 61,
      ny: 125,
    };
  };

  const fetchOpenWeatherData = async () => {
    try {
      
      // 서초구 지역 좌표 사용 (경원중학교)
      const params = {
        lat: 37.532551,
        lon: 127.10493,
      };

      const response = await getOpenWeatherData(params);

      if (response.data) {
        const data = response.data;
        const weather = {
          temperature: Math.round(data.current.temp),
          icon: data.current.weather[0].icon,
        };
        setWeatherData(weather);
        console.log("🌤️ OpenWeather 데이터 업데이트:", weather);
      }
    } catch (error) {
      console.error("OpenWeather 데이터 가져오기 실패:", error);
    }
  };

  // 현재 날씨 데이터 가져오기
  const fetchWeatherData = async () => {
    try {
      const now = new Date();
      const params = calculateWeatherParams(now);

      const response = await getWeatherData(params);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const weather = {};
        items.forEach((item) => {
          switch (item.category) {
            case "T1H": // 기온
              weather.temperature = item.obsrValue;
              break;
            case "PTY": // 강수형태
              weather.pty = item.obsrValue;
              break;
            default:
              break;
          }
        });
        setWeatherData((prevData) => ({ ...prevData, ...weather }));
        console.log("🌤️ 현재 날씨 데이터 업데이트:", weather);
      }
    } catch (error) {
      console.error("현재 날씨 데이터 가져오기 실패:", error);
      fetchOpenWeatherData(); // OpenWeather 데이터로 대체
    }
  };

  // 날씨 예보 데이터 가져오기 (하늘 상태용)
  const fetchWeatherForecast = async () => {
    try {
      const now = new Date();
      const params = calculateForecastParams(now);

      const response = await getWeatherForecastData(params);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const forecast = {};

        items.forEach((item) => {
          switch (item.category) {
            case "SKY": // 하늘 상태
              forecast.sky = item.fcstValue;
              break;
          }
        });

        setWeatherData((prev) => ({ ...prev, ...forecast }));
        console.log("🌤️ 날씨 예보 데이터 업데이트:", forecast);
      }
    } catch (error) {
      console.error("날씨 예보 데이터 가져오기 실패:", error);
    }
  };

  const fetchWeatherDataInDB = async () => {
    try {
      const params = { "x": 61, "y": 125} // 서초구(경원중학교) 좌표
      const res = await getWeatherDataInDB(params);
      const data = res?.data?.data;
      if (data) {
        setWeatherData((prev) => ({
          ...prev,
          temperature: Math.round(data.temp),
          sky: data.sky,
          pty: data.pty,
          icon: data.weather_icon,
        }));
      }
    } catch (error) {
      console.error("WeatherDataInDB 데이터 가져오기 실패:", error);
      fetchOpenWeatherData();
    }
  };
  // 날씨 타이머 시작
  const startWeatherTimer = useCallback(() => {
    if (weatherTimerRef.current) {
      clearInterval(weatherTimerRef.current);
    }

    console.log("🌤️ 날씨 데이터 타이머 시작");
    weatherTimerRef.current = setInterval(() => {
      const now = new Date();
      // 매시간 정각에 날씨 데이터 업데이트
      if (now.getMinutes() === 0) {
        // fetchWeatherData();
        // fetchWeatherForecast();
        fetchWeatherDataInDB();
      }
    }, 60000); // 1분마다 체크
  }, []);

  // 날씨 타이머 정지
  const stopWeatherTimer = useCallback(() => {
    if (weatherTimerRef.current) {
      clearInterval(weatherTimerRef.current);
      weatherTimerRef.current = null;
      console.log("🌤️ 날씨 데이터 타이머 정지");
    }
  }, []);

  // 현재 표시할 콘텐츠 설정 함수
  const getCurrentContentList = useCallback(() => {
    if (!gradeState) return null;

    const gradeAllList = autoDisplayEduViewLotationDataAll || [];

    switch (gradeState) {
      case "all":
        // all이면 gradeAll 리스트만
        return gradeAllList;
      case "grade1":
        // grade1이면 gradeAll + grade1 리스트
        const grade1List = autoDisplayEduViewLotationDataGrade1 || [];
        return [...gradeAllList, ...grade1List];
      case "grade2":
        // grade2이면 gradeAll + grade2 리스트
        const grade2List = autoDisplayEduViewLotationDataGrade2 || [];
        return [...gradeAllList, ...grade2List];
      case "grade3":
        // grade3이면 gradeAll + grade3 리스트
        const grade3List = autoDisplayEduViewLotationDataGrade3 || [];
        return [...gradeAllList, ...grade3List];
      case "gradeAll":
      default:
        // 기본값도 gradeAll 리스트만
        return gradeAllList;
    }
  }, [
    gradeState,
    autoDisplayEduViewLotationDataAll,
    autoDisplayEduViewLotationDataGrade1,
    autoDisplayEduViewLotationDataGrade2,
    autoDisplayEduViewLotationDataGrade3,
  ]);

  // 현재 콘텐츠 업데이트 함수
  const updateCurrentContent = useCallback(
    (contentList, index = 0) => {
      if (!contentList || contentList.length === 0) {
        setCurrentContent(null);
        return;
      }

      const content = contentList[index];
      if (!content) return;

      console.log("📋 현재 콘텐츠 업데이트:", content);

      setCurrentContent(content);

      // 각 콘텐츠의 속성을 상태에 설정
      setAutoDisplayEduViewContentsType(content.contentsType || "");
      setAutoDisplayEduViewDesignConcept(content.designConcept || "");
      setAutoDisplayEduViewContentGeneratorTitle(
        content.contentGeneratorTitle || ""
      );
      setAutoDisplayEduViewContentGeneratorMarkdown(
        content.contentGeneratorMarkdown || ""
      );
      setAutoDisplayEduViewContentsMeal(content.contentGeneratorMeal || {});
      setAutoDisplayEduViewNutritionMessage(
        content.nutritionMessage || ""
      );
      setLinkUrl(content.linkUrl || "");

      // meal 타입일 때는 lotationTime 변경하지 않음 (타이머에서 직접 처리)
      if (content.contentsType !== "meal") {
        // 개별 콘텐츠의 lotationTime이 있다면 업데이트 (우선순위: 개별 > 전역)
        if (content.lotationTime && content.lotationTime > 0) {
          const contentLotationTime = parseInt(content.lotationTime);
          if (contentLotationTime !== lotationTime) {
            setLotationTime(contentLotationTime);
            console.log(
              `⏰ 콘텐츠별 lotationTime 적용: ${contentLotationTime}초`
            );
          }
        }
      } else {
        console.log("🍽️ meal 타입 콘텐츠: 타이머에서 30초 고정 처리");
      }
    },
    [
      setAutoDisplayEduViewContentsType,
      setAutoDisplayEduViewDesignConcept,
      setAutoDisplayEduViewContentGeneratorTitle,
      setAutoDisplayEduViewContentGeneratorMarkdown,
      setAutoDisplayEduViewContentsMeal,
      setAutoDisplayEduViewNutritionMessage,
      lotationTime, // lotationTime 추가
    ]
  );

  // 다음 콘텐츠로 순환하는 함수
  const rotateToNextContent = useCallback(() => {
    setCurrentContentIndex((prevIndex) => {
      const contentList = getCurrentContentList();
      if (!contentList || contentList.length === 0) return prevIndex;

      const nextIndex = (prevIndex + 1) % contentList.length;
      console.log(
        `🔄 다음 콘텐츠로 순환: ${prevIndex} -> ${nextIndex} (총 ${contentList.length}개)`
      );

      updateCurrentContent(contentList, nextIndex);
      return nextIndex;
    });
  }, [getCurrentContentList, updateCurrentContent]);

  // 타이머 시작 함수 (콘텐츠 타입에 따라 다른 시간 적용)
  const startRotationTimer = useCallback(() => {
    if (rotationTimerRef.current) {
      clearInterval(rotationTimerRef.current);
    }

    // 재생 상태가 아니면 타이머 시작하지 않음
    if (!playing) {
      console.log("⏸️ 일시정지 상태이므로 타이머 시작하지 않음");
      return;
    }

    const contentList = getCurrentContentList();
    if (!contentList || contentList.length <= 1) {
      console.log("📋 콘텐츠가 1개 이하이므로 순환하지 않음");
      return;
    }

    // 현재 콘텐츠 타입에 따라 시간 결정
    const currentContent = contentList[currentContentIndex];
    let timerInterval = lotationTime * 1000; // 기본값

    if (currentContent && currentContent.contentsType === "meal") {
      timerInterval = 30 * 1000; // meal 타입은 30초 고정
      console.log(`🍽️ meal 타입 콘텐츠: 30초 타이머 시작`);
    } else {
      console.log(`⏰ 일반 콘텐츠: ${lotationTime}초 타이머 시작`);
    }

    rotationTimerRef.current = setInterval(() => {
      rotateToNextContent();
    }, timerInterval);
  }, [getCurrentContentList, lotationTime, rotateToNextContent, playing, currentContentIndex]);

  // 타이머 정지 함수
  const stopRotationTimer = useCallback(() => {
    if (rotationTimerRef.current) {
      clearInterval(rotationTimerRef.current);
      rotationTimerRef.current = null;
      console.log("⏹️ 순환 타이머 정지");
    }
  }, []);

  // viewId 추출 (URL 파라미터 또는 쿼리 파라미터에서)
  useEffect(() => {
    let extractedViewId = null;
    let extractedGradeState = null;

    // 1. URL 파라미터에서 추출 (/AutodisplayViewLinkEduLotation/viewId-grade1)
    if (path) {
      // '-' 기준으로 분리
      const parts = path.split("-");
      extractedViewId = parts[0];
      if (parts.length > 1) {
        extractedGradeState = parts[1];
      }
    }
    // 2. 쿼리 파라미터에서 추출 (?viewId=xxx)
    else {
      const queryParams = new URLSearchParams(location.search);
      extractedViewId = queryParams.get("viewId");
      extractedGradeState = queryParams.get("gradeState");
    }

    setViewId(extractedViewId);
    setGradeState(extractedGradeState);
    setUrlChecked(true);
  }, [path, location.search]);

  // 데이터 가져오기 함수
  const fetchData = useCallback(
    async (isInitial = false) => {
      try {
        if (isInitial) {
          setIsConnecting(true);
          setShowErrorPopup(false);
        }

        const activateTimestamp = Date.now();
        lastDataFetchTimeRef.current = activateTimestamp;

        if (isInitial) {
          setActivateTimestamp(activateTimestamp);
        }

        const data = {
          viewId: viewId,
          activateCode: "",
          activateLocation: "",
          activateIp: "",
          activateTimestamp: activateTimestamp,
        };

        const response = await viewDetailActivateLinkEduLotationRequest(data);
        console.log(
          "🚀 모바일: ~ fetchData ~ response:",
          response.lotationTable
        );

        // 응답 데이터의 lotationTime 사용
        if (response.lotationTable.lotationTime) {
          const newLotationTime = parseInt(response.lotationTable.lotationTime);
          if (newLotationTime > 0) {
            setLotationTime(newLotationTime);
            console.log(`⏰ 서버에서 받은 lotationTime: ${newLotationTime}초`);
          }
        }

        setAutoDisplayEduViewLotationDataAll(
          response.lotationTable.gradeAll || []
        );
        setAutoDisplayEduViewLotationDataGrade1(
          response.lotationTable.grade1 || []
        );
        setAutoDisplayEduViewLotationDataGrade2(
          response.lotationTable.grade2 || []
        );
        setAutoDisplayEduViewLotationDataGrade3(
          response.lotationTable.grade3 || []
        );

        return response;
      } catch (error) {
        console.error("모바일: 데이터 가져오기 중 오류 발생:", error);

        if (isInitial) {
          // 서버 응답 메시지 추출
          const serverMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "연결 중 오류가 발생했습니다. 다시 시도해주세요.";

          setErrorMessage(serverMessage);
          setShowErrorPopup(true);
        }
        throw error;
      } finally {
        if (isInitial) {
          setIsConnecting(false);
        }
      }
    },
    [viewId]
  );

  // 10분 간격 데이터 새로고침 타이머 시작
  const startDataRefreshTimer = useCallback(() => {
    if (dataRefreshTimerRef.current) {
      clearInterval(dataRefreshTimerRef.current);
    }

    console.log("📡 10분 간격 데이터 새로고침 타이머 시작");
    dataRefreshTimerRef.current = setInterval(async () => {
      try {
        console.log("🔄 10분 주기 데이터 새로고침 실행");
        await fetchData(false);
      } catch (error) {
        console.error("정기 데이터 새로고침 실패:", error);
      }
    }, 10 * 60 * 1000); // 10분 = 600초 = 600,000ms
  }, [fetchData]);

  // 데이터 새로고침 타이머 정지
  const stopDataRefreshTimer = useCallback(() => {
    if (dataRefreshTimerRef.current) {
      clearInterval(dataRefreshTimerRef.current);
      dataRefreshTimerRef.current = null;
      console.log("📡 데이터 새로고침 타이머 정지");
    }
  }, []);

  // 초기 데이터 로드
  useEffect(() => {
    if (!viewId) return;

    const initializeData = async () => {
      try {
        await fetchData(true);
        // 첫 데이터 로드 후 10분 간격 타이머 시작
        startDataRefreshTimer();
        
        // 날씨 데이터 초기 로드 및 타이머 시작
        // fetchWeatherData();
        // fetchWeatherForecast();
        fetchWeatherDataInDB();
        startWeatherTimer();
        
        // 데이터 로드 완료 후 약간의 지연을 두고 자동 재생 시작
        setTimeout(() => {
          console.log("🚀 초기 데이터 로드 완료, 자동 재생 시작");
          const contentList = getCurrentContentList();
          if (contentList && contentList.length > 1 && playing) {
            startRotationTimer();
          }
        }, 500);
      } catch (error) {
        console.error("초기 데이터 로드 실패:", error);
      }
    };

    initializeData();
  }, [viewId]); // viewId만 의존성으로 설정하여 무한 호출 방지

  // 재생 상태, lotationTime, 또는 현재 콘텐츠 인덱스 변경 시 타이머 제어
  useEffect(() => {
    const contentList = getCurrentContentList();
    if (!contentList || contentList.length <= 1) return;

    if (playing) {
      console.log(`▶️ 재생 시작/타이머 재시작 - 현재 인덱스: ${currentContentIndex}`);
      
      // 기존 타이머 정지
      if (rotationTimerRef.current) {
        clearInterval(rotationTimerRef.current);
      }
      
      // 현재 콘텐츠 타입에 따라 시간 결정
      const currentContent = contentList[currentContentIndex];
      let timerInterval = lotationTime * 1000; // 기본값

      if (currentContent && currentContent.contentsType === "meal") {
        timerInterval = 30 * 1000; // meal 타입은 30초 고정
        console.log(`🍽️ meal 타입 콘텐츠: 30초 타이머 시작`);
      } else {
        console.log(`⏰ 일반 콘텐츠: ${lotationTime}초 타이머 시작`);
      }
      
      // 새 타이머 시작
      rotationTimerRef.current = setInterval(() => {
        rotateToNextContent();
      }, timerInterval);
    } else {
      console.log(`⏸️ 일시정지 - 타이머 정지`);
      stopRotationTimer();
    }
  }, [playing, lotationTime, currentContentIndex]); // currentContentIndex 추가

  // 컴포넌트 언마운트 시 스크롤 복원 및 타이머 정리
  useEffect(() => {
    return () => {
      stopRotationTimer(); // 순환 타이머 정리
      stopDataRefreshTimer(); // 데이터 새로고침 타이머 정리
      stopWeatherTimer(); // 날씨 타이머 정리
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, [stopRotationTimer, stopDataRefreshTimer, stopWeatherTimer]);

  // 데이터 변경 시 콘텐츠 초기화 (재생 상태와 분리)
  useEffect(() => {
    if (!gradeState) return;

    const contentList = getCurrentContentList();
    if (!contentList || contentList.length === 0) {
      console.log("📋 콘텐츠 리스트가 없음");
      stopRotationTimer();
      setCurrentContent(null);
      return;
    }

    // 합쳐진 리스트 정보 로그
    const gradeAllCount = (autoDisplayEduViewLotationDataAll || []).length;
    let gradeSpecificCount = 0;
    let gradeInfo = "";

    switch (gradeState) {
      case "all":
        gradeInfo = `gradeAll만 (${gradeAllCount}개)`;
        break;
      case "grade1":
        gradeSpecificCount = (autoDisplayEduViewLotationDataGrade1 || [])
          .length;
        gradeInfo = `gradeAll(${gradeAllCount}개) + grade1(${gradeSpecificCount}개)`;
        break;
      case "grade2":
        gradeSpecificCount = (autoDisplayEduViewLotationDataGrade2 || [])
          .length;
        gradeInfo = `gradeAll(${gradeAllCount}개) + grade2(${gradeSpecificCount}개)`;
        break;
      case "grade3":
        gradeSpecificCount = (autoDisplayEduViewLotationDataGrade3 || [])
          .length;
        gradeInfo = `gradeAll(${gradeAllCount}개) + grade3(${gradeSpecificCount}개)`;
        break;
      default:
        gradeInfo = `gradeAll만 (${gradeAllCount}개)`;
        break;
    }

    console.log(
      `📊 ${gradeState} 데이터 변경 감지 - ${gradeInfo} = 총 ${contentList.length}개 콘텐츠`
    );

    // 기존 타이머 정지
    stopRotationTimer();

    // 첫 번째 콘텐츠로 초기화 (데이터 변경 시만)
    setCurrentContentIndex(0);
    updateCurrentContent(contentList, 0);

    // 재생 상태이고 콘텐츠가 2개 이상이면 자동으로 타이머 시작
    if (playing && contentList.length > 1) {
      setTimeout(() => {
        console.log("🚀 데이터 변경 후 자동 재생 시작");
        startRotationTimer();
      }, 500);
    }
  }, [
    gradeState,
    autoDisplayEduViewLotationDataAll,
    autoDisplayEduViewLotationDataGrade1,
    autoDisplayEduViewLotationDataGrade2,
    autoDisplayEduViewLotationDataGrade3,
    // playing 의존성 제거 - 재생 상태 변경 시 콘텐츠 인덱스 초기화 방지
  ]); // 함수 의존성 제거하여 무한 호출 방지

  // 재생/일시정지 토글 함수
  const handleTogglePlay = useCallback(() => {
    setPlaying(prev => {
      const newPlaying = !prev;
      console.log(`🎮 재생 상태 변경: ${prev ? '재생' : '일시정지'} -> ${newPlaying ? '재생' : '일시정지'}`);
      
      // useEffect에서 타이머 제어가 이루어지므로 여기서는 상태만 변경
      return newPlaying;
    });
  }, []);

  // 이전 콘텐츠로 이동
  const handlePrev = useCallback(() => {
    const contentList = getCurrentContentList();
    if (!contentList || contentList.length === 0) {
      console.log("📋 이전: 콘텐츠 리스트가 없음");
      // 데이터 로딩 재시도
      if (retryTimeoutRef.current) clearTimeout(retryTimeoutRef.current);
      let retryCount = 0;
      const maxRetries = 10;
      
      const retryGetContent = () => {
        const list = getCurrentContentList();
        if (list && list.length > 0) {
          console.log(`📋 재시도 성공: ${list.length}개 콘텐츠 발견`);
          const prevIndex = currentContentIndex > 0 ? currentContentIndex - 1 : list.length - 1;
          setCurrentContentIndex(prevIndex);
          updateCurrentContent(list, prevIndex);
          console.log(`⬅️ 이전 콘텐츠로 이동: ${currentContentIndex} -> ${prevIndex}`);
        } else if (retryCount < maxRetries) {
          retryCount++;
          console.log(`📋 재시도 ${retryCount}/${maxRetries}: gradeState=${gradeState}, 콘텐츠 개수=${list ? list.length : 0}`);
          retryTimeoutRef.current = setTimeout(retryGetContent, 300);
        } else {
          console.log("📋 재시도 실패: 최대 재시도 횟수 초과");
        }
      };
      
      retryGetContent();
      return;
    }

    setCurrentContentIndex(prevIndex => {
      const newIndex = prevIndex > 0 ? prevIndex - 1 : contentList.length - 1;
      console.log(`⬅️ 이전 콘텐츠로 이동: ${prevIndex} -> ${newIndex}`);
      updateCurrentContent(contentList, newIndex);
      return newIndex;
    });

    // 수동 조작 후 타이머 재시작 (콘텐츠 타입에 맞게)
    if (playing) {
      stopRotationTimer();
      setTimeout(() => {
        const newIndex = currentContentIndex > 0 ? currentContentIndex - 1 : contentList.length - 1;
        const newContent = contentList[newIndex];
        
        // 기존 타이머 정지
        if (rotationTimerRef.current) {
          clearInterval(rotationTimerRef.current);
        }
        
        // 콘텐츠 타입에 따라 시간 결정
        let timerInterval = lotationTime * 1000; // 기본값
        if (newContent && newContent.contentsType === "meal") {
          timerInterval = 30 * 1000; // meal 타입은 30초 고정
          console.log(`🍽️ 이전 버튼: meal 타입 콘텐츠 - 30초 타이머 재시작`);
        } else {
          console.log(`⏰ 이전 버튼: 일반 콘텐츠 - ${lotationTime}초 타이머 재시작`);
        }
        
        // 새 타이머 시작
        rotationTimerRef.current = setInterval(() => {
          rotateToNextContent();
        }, timerInterval);
      }, 1000);
    }
  }, [getCurrentContentList, currentContentIndex, updateCurrentContent, playing, stopRotationTimer, lotationTime, rotateToNextContent]);

  // 다음 콘텐츠로 이동
  const handleNext = useCallback(() => {
    const contentList = getCurrentContentList();
    if (!contentList || contentList.length === 0) {
      console.log("📋 다음: 콘텐츠 리스트가 없음");
      // 데이터 로딩 재시도
      if (retryTimeoutRef.current) clearTimeout(retryTimeoutRef.current);
      let retryCount = 0;
      const maxRetries = 10;
      
      const retryGetContent = () => {
        const list = getCurrentContentList();
        if (list && list.length > 0) {
          console.log(`📋 재시도 성공: ${list.length}개 콘텐츠 발견`);
          const nextIndex = (currentContentIndex + 1) % list.length;
          setCurrentContentIndex(nextIndex);
          updateCurrentContent(list, nextIndex);
          console.log(`➡️ 다음 콘텐츠로 이동: ${currentContentIndex} -> ${nextIndex}`);
        } else if (retryCount < maxRetries) {
          retryCount++;
          console.log(`📋 재시도 ${retryCount}/${maxRetries}: gradeState=${gradeState}, 콘텐츠 개수=${list ? list.length : 0}`);
          retryTimeoutRef.current = setTimeout(retryGetContent, 300);
        } else {
          console.log("📋 재시도 실패: 최대 재시도 횟수 초과");
        }
      };
      
      retryGetContent();
      return;
    }

    setCurrentContentIndex(prevIndex => {
      const newIndex = (prevIndex + 1) % contentList.length;
      console.log(`➡️ 다음 콘텐츠로 이동: ${prevIndex} -> ${newIndex}`);
      updateCurrentContent(contentList, newIndex);
      return newIndex;
    });

    // 수동 조작 후 타이머 재시작 (콘텐츠 타입에 맞게)
    if (playing) {
      stopRotationTimer();
      setTimeout(() => {
        const newIndex = (currentContentIndex + 1) % contentList.length;
        const newContent = contentList[newIndex];
        
        // 기존 타이머 정지
        if (rotationTimerRef.current) {
          clearInterval(rotationTimerRef.current);
        }
        
        // 콘텐츠 타입에 따라 시간 결정
        let timerInterval = lotationTime * 1000; // 기본값
        if (newContent && newContent.contentsType === "meal") {
          timerInterval = 30 * 1000; // meal 타입은 30초 고정
          console.log(`🍽️ 다음 버튼: meal 타입 콘텐츠 - 30초 타이머 재시작`);
        } else {
          console.log(`⏰ 다음 버튼: 일반 콘텐츠 - ${lotationTime}초 타이머 재시작`);
        }
        
        // 새 타이머 시작
        rotationTimerRef.current = setInterval(() => {
          rotateToNextContent();
        }, timerInterval);
      }, 1000);
    }
  }, [getCurrentContentList, currentContentIndex, updateCurrentContent, playing, stopRotationTimer, lotationTime, rotateToNextContent]);

  return (
    <FullScreenContainer>
      <AnimationWrapper key={currentContentIndex}>
        {autoDisplayEduViewContentsType === "meal" ? (
          <ComponentWrapper>
            <ComponentContainer style={{ transform: `scale(${scale.x}, ${scale.y})` }}>
              <MoleculeMenuBoard
                backgroundImage={autoDisplayEduViewDesignConcept}
                menuData={autoDisplayEduViewContentsMeal}
                noticeText={autoDisplayEduViewNutritionMessage}
                weatherData={weatherData}
              />
            </ComponentContainer>
          </ComponentWrapper>
        ) : (
          <ComponentWrapper>
            <ComponentContainer style={{ transform: `scale(${scale.x}, ${scale.y})` }}>
              {autoDisplayEduViewContentsType === "link" ? (
                <MoleculeBackgroundSimpleWideLink
                  contentsDesignConcept={autoDisplayEduViewDesignConcept}
                  title={autoDisplayEduViewContentGeneratorTitle}
                  content={autoDisplayEduViewContentGeneratorMarkdown}
                  weatherData={weatherData}
                  linkUrl={linkUrl}
                  onTogglePlay={handleTogglePlay}
                />
              ) : (
                <MoleculeBackgroundSimpleWide
                  contentsDesignConcept={autoDisplayEduViewDesignConcept}
                  title={autoDisplayEduViewContentGeneratorTitle}
                  content={autoDisplayEduViewContentGeneratorMarkdown}
                  weatherData={weatherData}
              />
            )}
            </ComponentContainer>
          </ComponentWrapper>
        )}
      </AnimationWrapper>
      
      <MoleculePlayFloating
        isPlaying={playing}
        onTogglePlay={handleTogglePlay}
        onPrev={handlePrev}
        onNext={handleNext}
        floating={true}
        zIndex={9999}
        style={{
          position: "fixed",
          bottom: "20px",
          left: "50%",
          transform: `translateX(-50%) scale(${scale.x}, ${scale.y})`,
          transformOrigin: "center bottom",
        }}
      />

      <MoleculeFullScreenButton 
      style={{
        transform: `scale(${scale.x}, ${scale.y})`,
        transformOrigin: "bottom right",
      }}
      />
    </FullScreenContainer>
  );
};

export default PageAutodisplayViewLinkEduMobileLotation;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const AnimationWrapper = styled.div`
  width: 100%;
  height: 100%;
  animation: ${slideIn} 0.5s ease-out;
`;

// 스타일 컴포넌트들 (원래 코드 기반)
const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: white;
  overflow: hidden;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  /* 스크롤바 숨김 */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  /* 스크롤바 스타일링
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  } */
`;

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  z-index: 9999;
`;

const LoadingSpinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #333;
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.div`
  color: black;
  font-size: 18px;
  font-weight: 600;
`;

const LoadingSubText = styled.div`
  color: #666;
  font-size: 14px;
  text-align: center;
`;

// 실제 차지하는 공간을 조정하는 wrapper (화면에 꽉 차게)
const ComponentWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ComponentContainer = styled.div`
  width: 3840px;
  height: 2160px;
  background: white;
  position: relative;
  overflow: hidden;
  transform-origin: center;
  flex-shrink: 0;
`;

const StyledMainDescription = styled.span`
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
`;

const StyledThickLine = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 3px black solid;
  outline-offset: -2px;
`;

const StyledSectionTitle = styled.span`
  width: 144px;
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
`;

const StyledSectionContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledBulletItem = styled.div`
  width: 688px;
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
  padding-left: 32px;
  text-indent: -22px;
`;

const StyledThinLine = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 1px black solid;
  outline-offset: 0px;
`;

const StyledSectionRow = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  display: inline-flex;
`;

const StyledContentContainerForModern = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
`;
